"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
/**Tamaño de una unidad de indentación en pixeles */
const indentUnitSize = 20;
class CollapsedIcon extends React.PureComponent {
    render() {
        const i = this.props.collapsed == "collapsed" ? "plus-" :
            this.props.collapsed == "expanded" ? "minus-" :
                this.props.collapsed == "leaf" ? "" : this.props.collapsed;
        const icon = `fa fa-${i}square-o fa-fw`;
        return React.createElement("i", { className: icon });
    }
}
/**Dibuja una fila del arbol. El contenido de la fila será el contenido  */
class TreeRowComponent extends React.PureComponent {
    render() {
        const props = this.props;
        return (React.createElement("tr", null,
            React.createElement("td", { style: { width: "1px", borderRight: "solid 2px #0003" } },
                React.createElement("div", { style: { display: "flex" } },
                    React.createElement("div", { style: { width: indentUnitSize * this.props.path.length + "px", flex: "0 1 auto" } }),
                    React.createElement("div", { style: { flex: "0 1 auto" }, onClick: props.collapsed != "leaf" ? (() => props.onCollapsedChange(props.collapsed != "collapsed")) : undefined },
                        React.createElement(CollapsedIcon, { collapsed: props.collapsed })),
                    React.createElement("div", { style: { flex: "1 0 auto", fontWeight: "bold" } }, this.props.path[this.props.path.length - 1]))),
            React.createElement("td", null, this.props.children)));
    }
}
exports.TreeRowComponent = TreeRowComponent;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/treeview/row.js
// module id = 2262
// module chunks = 0